import { classNameParser } from "../../../helpers";
import { Props } from "../../../types";
import "./style.css";

type LabeledValueProps = Props<{
  label: string;
  unit?: string;
  size?: "mini" | "xsmall" | "small" | "large";
  colorClass?: string;
}>;

export const LabeledValue = (props: LabeledValueProps) => (
  <div
    className={classNameParser(`labeled-value${props.size === 'large' ? `--large` : ""}`, props.className)}
    style={props.style}
  >
    {!!props.label ? (
      <div
        className={`${
          props.size === "large"
            ? "mb-[12px]"
            : props.size === "mini"
            ? "mb-[5px]"
            : props.size === undefined
            ? "mb-[14px]"
            : ""
        } ${props.colorClass || ""}`}
      >
        <label className="subtitle-medium">{props.label}</label>
      </div>
    ) : null}
    <div className={`labeled-value--value${props.size === 'large' ? `-large` : ""}`}>{props.children}</div>
  </div>
);

export const ValueSub = (props: Props) => (
  <sub className={props.className} style={props.style}>
    {props.children}
  </sub>
);

export const ValueSup = (props: Props) => (
  <sup className={props.className} style={props.style}>
    {props.children}
  </sup>
);

export const ValueBox = (props: Props) => (
  <div className={classNameParser("labeled-value--box", props.className)} style={props.style}>
    {props.children}
  </div>
);
